import React from 'react'
import TimelineSummaryHeader from './TimelineSummaryHeader'
import ScheduleTimelineItems from '../common_components/ScheduleTimelineItems'
import TasksHelper from '../../support/TasksHelper.js'

class TimelineSummaryDetail extends React.Component {
  constructor() {
    super()
    this.state = {
      showData: true
    }
  }

  _manageTimelineData(data) {
    return this.props.manageTimelineData(data);
  }
  _countTimelineItems() {
    return TasksHelper._countTaskItems(this.props.show_hidden_tasks, this.props.timeline_events.uncompleted_items, this.props.timeline_events.completed_items, this.props.show_essential_tasks, this.props.show_recommended_tasks, this.props.show_information_only_tasks) > 0;
  }
  _onHelpfulCheck(data){
    return this.props.onHelpfulCheck(this.props.date, data);
  }

  chevronArrow(showData) {
    this.setState({ showData : showData })
  }

  renderScheduleTimelineItems() {
    return (
      <ScheduleTimelineItems
        timeline_events={this.props.timeline_events}
        manageTimelineData={this._manageTimelineData.bind(this)}
        handleItemClick={this.props.handleItemClick}
        display_modal={this.props.display_modal}
        onHelpfulCheck={this._onHelpfulCheck.bind(this)}
        handleJustLookingClick={this.props.handleJustLookingClick}
        show_hidden_tasks={this.props.show_hidden_tasks}
        handleCustomTaskDelete={this.props.handleCustomTaskDelete}
        handleCustomTaskChange={this.props.handleCustomTaskChange}
        handleCustomTaskClick={this.props.handleCustomTaskClick}
        custom_task_modal={this.props.custom_task_modal}
        show_essential_tasks={this.props.show_essential_tasks}
        show_recommended_tasks={this.props.show_recommended_tasks}
        show_information_only_tasks={this.props.show_information_only_tasks}
        isLeavePlanPartner={this.props.isLeavePlanPartner}
        disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
      />
    )
  }

    renderTimelineSummaryHeader() {
      return (
        <TimelineSummaryHeader
          date={this.props.date}
          title={this.props.title}
          timeline_events={this.props.timeline_events}
          showSummary={this._showSummary }
          chevronArrow={this.chevronArrow.bind(this) }
          handleItemClick={this.props.handleItemClick}
          display_modal={this.props.display_modal}
          onHelpfulCheck={this._onHelpfulCheck.bind(this)}
          handleJustLookingClick={this.props.handleJustLookingClick }
          show_hidden_tasks={this.props.show_hidden_tasks}
          show_essential_tasks={this.props.show_essential_tasks}
          show_recommended_tasks={this.props.show_recommended_tasks}
          show_information_only_tasks={this.props.show_information_only_tasks}
        />
      )
    }

    render() {
      if (this._countTimelineItems()) {
        return (
          <div className='timeline-summary-detail' data-date={this.props.date}>
            <div className='pointer'>
            </div>
            { this.renderTimelineSummaryHeader() }
            { this.state.showData ? this.renderScheduleTimelineItems(): '' }
          </div>
         )
      } else {
        return(<div/>)
      }
    }
}

export default TimelineSummaryDetail
